import React, { useState, useEffect } from 'react';
import './choicecommon_v.css'

function OtherOption({type, commonProps, values, setValues})
{
    const [userValue, setUserValue] = useState('')
    return (
	<>
	    <div className="form-check">
		<input className="form-check-input"
		       type={type}
		       value={commonProps.otherOptionValue}
		       name={commonProps.dataFields[0].id}
		       id={"id-" + commonProps.dataFields[0].id}
		       onChange={ev => setValues(ev.target.checked, ev.target.value, userValue)}/>
		<label className="w-100 form-check-label tertiary-text"
		       htmlFor={"id-" + commonProps.dataFields[0].id}>
		    {commonProps.otherOptionValue}
		</label>
	    </div>
	    {values.values.includes(commonProps.otherOptionValue) &&
	     commonProps.otherOption === 'addwithinput' && (
		<div class="mb-2">
		    {commonProps.otherInput && commonProps.otherInput.numRows === 1 ? (
			<input type="text"
			       class="form-control"
			       name={commonProps.otherInput.inputId}
			       style={{width: 'auto'}}
			       size={commonProps.otherInput.numCols}
			       placeholder={commonProps.otherInput.label}
			       value={values.otherValue}
			       onChange={ev => {
				   setUserValue(ev.target.value)
				   setValues(true, commonProps.otherOptionValue, ev.target.value)
			       }}/>
		    ) : (
			<textarea class="form-control"
				  rows={commonProps.otherInput ? commonProps.otherInput.numRows : 2}
				  cols={commonProps.otherInput ? commonProps.otherInput.numCols : 25}
				  name={step.otherInput.inputId}
				  placeholder={commonProps.otherInput ? commonProps.otherInput.label : 'please specify'}
				  value={values.otherValue}
				  onChange={ev => {
				      setUserValue(ev.target.value)
				      setValues(true, common.otherOptionValue, ev.target.value)
				  }}
				  style={{width: 'auto'}}/>
		    )}
		</div>
	    )}
	</>
    )
}

export function ChoiceTree({type, data, level, commonProps, values, setValues})
{
    if ( ! data ) return
    const mapCols = nc => {
	if ( nc > 6 ) return 1
	else if ( nc <= 6 && nc > 4 ) return 2
	else if ( nc === 4 ) return 3
	else if ( nc === 3 ) return 4
	else if ( nc === 2 ) return 6
	else return 12
    }
    const [numCols, setNumCols] = useState(mapCols(commonProps.numColumns))
    useEffect(() => {
	setNumCols(mapCols(commonProps.numColumns))
    }, [commonProps.numColumns])
    if ( data.constructor === Array ) {
	return (
	    <div className={"row " + `level-${level} array`}>
		{data.map((item, ii) => {
		    if ( level === 1 && typeof(item) === 'string' ) {
			return (
			    <div key={ii} className={"col-" + numCols}>
				<ChoiceTree type={type}
					    level={level+1}
					    data={item}
					    commonProps={commonProps}
					    values={values}
					    setValues={setValues}/>
			    </div>
			)
		    } else {
			return (
			    <div key={ii}>
				<ChoiceTree type={type}
					    level={level+1}
					    data={item}
					    commonProps={commonProps}
					    values={values}
					    setValues={setValues}/>
			    </div>
			)
		    }
		})}
	    </div>
	)
    } else if ( data.constructor === Object ) {
	return (
	    <div className={"row " + `level-${level} object`}>
		{Object.keys(data).map((key, ki) => (
		    <div className={"col-" + numCols} key={ki}>
			<span className="tertiary-text">{key}</span>
			<ChoiceTree type={type}
				    level={level+1}
				    data={data[key]}
				    commonProps={commonProps}
				    values={values}
				    setValues={setValues}/>
		    </div>
		))}
		{level === 1 && commonProps.otherOption !== 'none' && (
		    <OtherOption type={type}
				 commonProps={commonProps}
				 values={values}
				 setValues={setValues}/>
		)}
	    </div>
	)
    } else {
	return (
	    <div className="form-check form-check-inline">
		<input type={type}
		       className="ms-1 me-2 form-check-input"
		       id={"id-" + level + "-" + data}
		       value={data}
		       name={commonProps.dataFields[0].id}
		       onChange={ev => setValues(ev.target.checked, ev.target.value)}/>
		<label className="form-check-label tertiary-text"
		       htmlFor={"id-" + level + "-" + data}>
		    {data}
		</label>
	    </div>
	)
    }
}

export function useChoiceTree(otherOptionValue)
{
    const [values, setValues] = useState({values: []})
    function addOrRemoveValue(checked, value, otherValue)
    {
	/* Used or setting check/radio as well as otherValue
	 * when "Other" is selected. otherValue can be
	 * (null|undefined). */
	if ( checked ) {
	    if ( values.values.includes(value) ) {
		if ( value === otherOptionValue ) setValues(prev => ({...prev, otherValue: otherValue}))
		return
	    } else {
		if ( value === otherOptionValue )
		    setValues(prev => ({...prev, otherValue: otherValue, values: [...prev.values, value]}))
		else
		    setValues(prev => ({...prev, values: [...prev.values, value]}))
	    }
	} else {
	    /* removal */
	    const index = values.values.findIndex(x => x === value)
	    if ( index === -1 ) {
		if ( value === otherOptionValue ) setValues(prev => ({...prev, otherValue: null}))
		return
	    } else {
		if ( value === otherOptionValue )
		    setValues(prev => ({...prev,
					otherValue: null,
					values: [...prev.values.slice(0, index),
						 ...prev.values.slice(index+1)]}))
		else
		    setValues(prev => ({...prev,
					values: [...prev.values.slice(0, index),
						 ...prev.values.slice(index+1)]}))
	    }
	}
    }
    return [ values, setValues, addOrRemoveValue ]
}
